import React from "react";

export const IconTable = () => {
    return (
        <svg
            id="Layer_2"
            data-name="Layer 2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 228 183"
            width="19"
            height="19"
        >
            <g id="Layer_1-2" data-name="Layer 1">
                <rect
                    x="10"
                    y="10"
                    width="208"
                    height="163"
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeWidth="20"
                />
                <rect
                    x="12.5"
                    y="10.5"
                    width="203"
                    height="15"
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeWidth="20"
                />
                <path
                    d="M118.5,18.5V168.55"
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeWidth="20"
                />
                <line
                    x1="12.5"
                    y1="98.78"
                    x2="215.5"
                    y2="98.78"
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeWidth="20"
                />
                <line
                    x1="215.5"
                    y1="39.5"
                    x2="12.5"
                    y2="39.5"
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeWidth="20"
                />
            </g>
        </svg>
    );
};
